import React from 'react';
import {
  Box,
  Icon,
  Text,
  Flex,
  HStack,
  Circle,
  Heading,
} from '@chakra-ui/react';
import {
  FaHome,
  FaUtensils,
  FaClipboardList,
  FaUtensilSpoon,
  FaShoppingBasket,
  FaCog,
  FaChartLine,
  FaWallet,
  FaExchangeAlt,
  FaBell,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Sidebar = () => {

   return (
    <Box p={4} bg="blackAlpha.900">      
      <Flex direction="column" align="stretch">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="left"
          mb={4}
        >
          <Circle
            size="50px"
            bg="white"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon
              as={FaUtensilSpoon}
              color="black"
              fontSize="24px"
            />
          </Circle>
        </Box>       
          <Heading color="white" fontSize="lg" mb={2}>Restaurant Name</Heading>          
        <Link to="/restaurant" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaHome} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Home</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-menu" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaUtensils} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>My Menu</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-orders" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaClipboardList} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Orders</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-market-place" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaShoppingBasket} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Market Place</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-analytics" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaChartLine} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Analytics</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-wallet" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaWallet} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Wallet</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-trades" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaExchangeAlt} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Trades</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-notifications" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaBell} color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Notifications</Text>
          </HStack>
        </Link>
        <Link to="/restaurant-settings" >
          <HStack spacing={2} mt={2}>
            <Icon as={FaCog}  color="white" mr={2} />
            <Text color="white" _hover={{ textDecoration: 'underline', color: 'blue.50' }}>Settings</Text>
          </HStack>
        </Link>        
      </Flex>
    
    </Box>
  );
};

export default Sidebar;